import React, { useEffect, useState } from "react";
import { Star, User, Mail, Phone, Globe, Check, Flag } from "lucide-react";
import InputText from "../ReusableComponents/InputText";
import TextArea from "../ReusableComponents/TextArea";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import { BindAPI, IUDAPI, ImageAPI } from "../services/APIConnection";






const Feedbackform = () => {
    const [isOpen, setIsOpen] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [submitBtnDisabled, setSubmitBtnDisabled] = useState(false);
    const [mstFeedbackId, setMstFeedbackId] = useState("");
    const [rowIndex, setRowIndex] = useState(null);
    const [bindFeedbackformData, setBindFeedbackformData] = useState([]);
    const navigate = useNavigate();
    var createdBy = sessionStorage.getItem("createdBy");
    const [formfields, setformfields] = useState({
        MstfeedbackId: "",
        Name: "",
        Email: "",
        MobileNumber: "",
        Country: "",
        Questions1: "",
        Questions2: "",
        Questions3: "",
        Questions4: "",
        Questions5: "",
        Questions6: "",
        Questions7: "",
        Questions8: "",
        Questions9: "",
        Questions10: "",
        Facilities: "",
        checkOut: "",       // updated
        checkIn: "",        // updated
        home: "",           // updated
        location: "",       // updated
        Safety: "",         // already present
        Food: "",           // already present
        Recreational: "",   // already present
        Bed: "",            // already present
        Peaceful: "",       // already present
        suggestions: "",
    });


    const [formfieldsErrors, setformfieldsErrors] = useState({
        Name: "",
        Email: "",
        MobileNumber: "",
        Country: "",

    });


    useEffect(() => {
        bindFeedbackform();
    }, []);

    const bindFeedbackform = async () => {
        const data = {}
        // const response = await IUDAPI([data], "FeedbackFormAPI/IUDFeedbackForm");
        // const result = response?.data?.Table?.[0]?.Result;
        // setBindFeedbackformData(response.data.Table);
        // console.log(response.data.Table);
    };

    const cancel = () => {
        navigate("/dashboard");
        setSubmitBtnDisabled(false);


    };
    // const handleChange = (e) => {
    //   const { name, value } = e.target;
    //   setformfields({ ...formfields, [name]: value });
    // };

    const handleRatingChange = (field, value) => {
        setformfields((prev) => ({
            ...prev,
            [field]: value,
        }));
    };



    const handleSubmit = async (e) => {
        e.preventDefault();

        setSubmitBtnDisabled(true);
        setIsLoading(true);



        setIsOpen(false);

        const data = {
            MstfeedbackId: mstFeedbackId ? mstFeedbackId : 0,
            Name: formfields.Name,
            Email: formfields.Email,
            MobileNumber: formfields.MobileNumber,
            Country: formfields.Country,
            Questions1: formfields.Questions1,
            Questions2: formfields.Questions2,
            Questions3: formfields.Questions3,
            Questions4: formfields.Questions4,
            Questions5: formfields.Questions5,
            Questions6: formfields.Questions6,
            Questions7: formfields.Questions7,
            Questions8: formfields.Questions8,
            Questions9: formfields.Questions9,
            Questions10: formfields.Questions10,
            FacilitiesActivities: formfields.Facilities,
            LocationArea: formfields.location,
            CheckoutProcess: formfields.checkOut,
            CheckinProcess: formfields.checkIn,
            HomeCondition: formfields.home,
            SafetySecurity: formfields.Safety,
            FoodDining: formfields.Food,
            RecreationalActivities: formfields.Recreational,
            BedFurniture: formfields.Bed,
            PeacefulRelaxing: formfields.Peaceful,
            suggestions: formfields.suggestions,
            createdBy: createdBy,
            flag: 1,
        };

        try {
            const response = await IUDAPI([data], "FeedbackFormAPI/IUDFeedbackForm");
            const result = response?.data?.Table?.[0]?.Result;

            if (result === "S") {
                toast.success("✅ Feedback submitted successfully!", {
                    duration: 3000,
                    position: "top-center",
                });
                setTimeout(cancel, 3000);
            } else {
                toast.error("❌ Failed to submit feedback. Please try again.", {
                    duration: 3000,
                    position: "top-center",
                });
            }
        } catch (error) {
            toast.error("❌ Something went wrong!", {
                duration: 3000,
                position: "top-center",
            });
            console.error("Submission error:", error);
        }

        setIsLoading(false);
        setSubmitBtnDisabled(false);
    };



    return (
        <form
            onSubmit={handleSubmit}
            className="max-w-4xl mx-auto p-10 bg-gradient-to-r from-cyan-100 via-white to-emerald-100 rounded-3xl shadow-2xl font-[Poppins] border border-gray-200"
        >
            <h2 className="text-4xl font-extrabold text-center mb-10 text-blue-800 drop-shadow-md">
                Your Stay  🏡 Your Story  🌅
            </h2>


            {/* <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-10">
        {[
          { icon: <User className="w-4 h-4" />, label: "Name", name: "name", type: "text" },
          { icon: <Mail className="w-4 h-4" />, label: "Email", name: "email", type: "email" },
          { icon: <Phone className="w-4 h-4" />, label: "Mobile Number", name: "mobile", type: "tel" },
          { icon: <Globe className="w-4 h-4" />, label: "Country", name: "country", type: "text" },
        ].map(({ icon, label, name, type }) => (
          <div key={name}>
            <label className="block mb-2 font-medium flex items-center gap-2 text-gray-700">
              {icon} {label}
            </label>
            <InputText
              type={type}
              name={name}
              value={form[name]}
              onChange={handleChange}
              className="w-full p-3 rounded-xl shadow-md border border-gray-300 focus:ring-2 focus:ring-blue-400 bg-white"
              required={name === "name" || name === "email"}
            />
          </div>
        ))}
      </div> */}


            <div class="grid gap-4 mb-6 md:grid-cols-2">
                <InputText
                    inputType={"text"}
                    title={" Name"}
                    icon={<User size={18} />}
                    name={" Name"}
                    disabled={false}
                    placeholder="Enter the Name"
                    classStar={"text-red-500"}
                    content={formfields.Name}
                    controlFunc={(e) =>
                        setformfields({
                            ...formfields,
                            Name: e.target.value,
                        })
                    }

                />

                <InputText

                    inputType={"text"}
                    title={"Mobile Number"}
                    name={"mobileNumber"}
                    classStar={"text-red-500"}
                    maxLength={11}
                    icon={<Phone size={18} />}
                    content={formfields.MobileNumber}
                    controlFunc={(e) =>
                        setformfields({
                            ...formfields,
                            MobileNumber: e.target.value,
                        })
                    }
                />

                <InputText
                    inputType={"text"}
                    title={"Email"}
                    name={"email"}
                    classStar={"text-red-500"}
                    icon={<Mail size={18} />}
                    content={formfields.Email}
                    controlFunc={(e) =>
                        setformfields({
                            ...formfields,
                            Email: e.target.value,
                        })
                    }
                />

                <InputText
                    inputType={"text"}
                    title={" Country"}
                    name={" country"}
                    disabled={false}
                    placeholder="Enter the Country"
                    classStar={"text-red-500"}
                    icon={<Globe size={18} />}
                    content={formfields.Country}
                    controlFunc={(e) =>
                        setformfields({
                            ...formfields,
                            Country: e.target.value,
                        })
                    }
                />

            </div>


            <div className="mb-10">
                {/* <div className="grid grid-cols-1 sm:grid-cols- lg:grid-cols-4 gap-4 p-4"> */}
                <label className="block mb-4 text-xl font-semibold text-gray-800">
                    How did you hear about our resort?
                </label>
                <TextArea
                    title=""
                    name="experience "
                    content={formfields.Questions1}
                    controlFunc={(e) =>
                        setformfields({
                            ...formfields,
                            Questions1: e.target.value,
                        })
                    }
                />
            </div>


            <div className="mb-10">
                <label className="block mb-4 text-xl font-semibold text-gray-800">
                    How did you enjoy your time at our resort?
                </label>
                <TextArea
                    title=""
                    name="experience memorable"
                    content={formfields.Questions2}
                    controlFunc={(e) =>
                        setformfields({
                            ...formfields,
                            Questions2: e.target.value,
                        })
                    }
                />
            </div>
            <div className="mb-10">
                <label className="block mb-4 text-xl font-semibold text-gray-800">
                    What did you enjoy the most during your stay?
                </label>
                <TextArea
                    title=""
                    name="experience memorable"
                    content={formfields.Questions3}
                    controlFunc={(e) =>
                        setformfields({
                            ...formfields,
                            Questions3: e.target.value,
                        })
                    }
                />
            </div>
            <div className="mb-10">
                <label className="block mb-4 text-xl font-semibold text-gray-800">
                    What was your most memorable moment at the resort?
                </label>
                <TextArea
                    title=""
                    name="experience memorable"
                    content={formfields.Questions4}
                    controlFunc={(e) =>
                        setformfields({
                            ...formfields,
                            Questions4: e.target.value,
                        })
                    }
                />
            </div>
            <div className="mb-10">
                <label className="block mb-4 text-xl font-semibold text-gray-800">
                    What could we improve to make your next stay better?
                </label>
                <TextArea
                    title=""
                    name="experience memorable"
                    content={formfields.Questions5} controlFunc={(e) =>
                        setformfields({
                            ...formfields,
                            Questions5: e.target.value,
                        })
                    }
                />
            </div>
            <div className="mb-10">
                <label className="block mb-4 text-xl font-semibold text-gray-800">
                    Were there any surprises—positive or negative—during your stay?
                </label>
                <TextArea
                    title=""
                    name="experience memorable"
                    content={formfields.Questions6}
                    controlFunc={(e) =>
                        setformfields({
                            ...formfields,
                            Questions6: e.target.value,
                        })
                    }
                />
            </div>
            <div className="mb-10">
                <label className="block mb-4 text-xl font-semibold text-gray-800">
                    Did you feel all types of guests were welcomed and respected?
                </label>
                <TextArea
                    title=""
                    name="experience memorable"
                    content={formfields.Questions7}
                    controlFunc={(e) =>
                        setformfields({
                            ...formfields,
                            Questions7: e.target.value,
                        })
                    }
                />
            </div>
            <div className="mb-10">
                <label className="block mb-4 text-xl font-semibold text-gray-800">
                    Did you face any issues with the room during your stay?
                </label>
                <TextArea
                    title=""
                    name="experience memorable"
                    content={formfields.Questions8}
                    controlFunc={(e) =>
                        setformfields({
                            ...formfields,
                            Questions8: e.target.value,
                        })
                    }
                />
            </div>
            <div className="mb-10">
                <label className="block mb-4 text-xl font-semibold text-gray-800">
                    Did you enjoy the surrounding nature, beach, or views?
                </label>
                <TextArea
                    title=""
                    name="experience memorable"
                    content={formfields.Questions9}
                    controlFunc={(e) =>
                        setformfields({
                            ...formfields,
                            Questions9: e.target.value,
                        })
                    }
                />
            </div>
            <div className="mb-10">
                <label className="block mb-4 text-xl font-semibold text-gray-800">
                    Did the resort meet your expectations?
                </label>
                <TextArea
                    title=""
                    name="experience memorable"
                    content={formfields.Questions10}
                    controlFunc={(e) =>
                        setformfields({
                            ...formfields,
                            Questions10: e.target.value,
                        })
                    }
                />
                {/* </div> */}
            </div>


            <div className="mb-10 space-y-6">
                <div className="block text-2xl font-bold text-gray-900">
                    Rate aspects of your stay
                </div>
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 p-4">
                    {[
                        { field: "checkIn", label: "Check-in process" },
                        { field: "home", label: "Home condition" },
                        { field: "location", label: "Location & Area" },
                        { field: "checkOut", label: "Check-out process" },
                        { field: "Facilities", label: "Facilities & activities" },
                        { field: "Safety", label: "Safety & Security" },
                        { field: "Food", label: "Food & Dining" },
                        { field: "Recreational", label: "Recreational Activities" },
                        { field: "Bed", label: "Bed & Furniture" },
                        { field: "Peaceful", label: "Peaceful & Relaxing" },
                    ].map(({ field, label }) => (
                        <div key={field} className="space-y-1">
                            <div className="text-sm font-medium text-gray-700">{label}</div>
                            <div className="flex gap-2">
                                {[1, 2, 3, 4, 5].map((val) => {
                                    const isActive = formfields[field] >= val;
                                    return (
                                        <div
                                            key={val}
                                            onClick={() => handleRatingChange(field, val)}
                                            className={`relative w-7 h-7 rounded-full border-2 flex items-center justify-center cursor-pointer transition
                    ${isActive
                                                    ? "bg-green-500 border-yellow -600"
                                                    : "bg-white border-gray-300 hover:border-green-400"
                                                }`}
                                        >
                                            <div
                                                className={`w-4 h-4 rounded-full flex items-center justify-center
                      ${isActive ? "text-white" : "text-gray-400"}`}
                                            >
                                                {isActive ? <Check className="w-3 h-3" /> : <Star className="w-3 h-3" />}
                                            </div>
                                        </div>
                                    );
                                })}
                            </div>
                        </div>
                    ))}
                </div>
            </div>




            <div>
                <div className="block text-xl font-semibold text-gray-800 mb-2">
                    What did you enjoy most about your visit?
                </div>

                <TextArea
                    title=""
                    name="suggestions"
                    content={formfields.suggestions}
                    controlFunc={(e) =>
                        setformfields({
                            ...formfields,
                            suggestions: e.target.value,
                        })
                    }
                />


            </div>


            <div className="text-center">
                <button
                    type="submit"
                    className="bg-gradient-to-r from-blue-600 to-purple-600 text-white px-8 py-3 rounded-xl shadow-md hover:from-blue-700 hover:to-purple-700 transition"
                >
                    Submit Feedback
                </button>
            </div>



            <div className="text-center text-lg font-semibold text-gray-700 mt-8">
                Thank you for sharing your thoughts! 💬<br />
                We hope to welcome you again soon 🌟
            </div>
        </form>
    );
};

export default Feedbackform;
